import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import PricingPolicy from '@type/pricingPolicy'

const getGlobalDiscount = (): Promise<PricingPolicy> => {
  return new Promise((resolve, reject) => {
    const URL = routes.GLOBAL_DISCOUNTS + '/global-discount/active'

    AxiosClient.get(URL)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
export default getGlobalDiscount
